import React from 'react';

interface HelpIconProps {
  width?: number;
  height?: number;
  fill?: string;
}

export const HelpIcon: React.FC<HelpIconProps> = ({
  width = 20,
  height = 20,
  fill = '#292929'
}) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      viewBox="0 0 20 20"
      fill="none"
    >
      <path
        d="M9.9881 15.5268C9.75745 15.5349 9.53272 15.4529 9.36149 15.2982C9.03116 14.9331 9.03116 14.3771 9.36149 14.0121C9.53084 13.8536 9.75632 13.769 9.98813 13.777C10.2245 13.7676 10.454 13.8574 10.6212 14.0248C10.7832 14.1927 10.8703 14.4191 10.8625 14.6523C10.8749 14.8873 10.7929 15.1175 10.6348 15.2917C10.4612 15.4565 10.227 15.5416 9.9881 15.5268Z"
        fill={fill}
      />
      <path
        d="M10 18.75C5.1748 18.75 1.25 14.8252 1.25 10C1.25 5.1748 5.1748 1.25 10 1.25C14.8252 1.25 18.75 5.1748 18.75 10C18.75 14.8252 14.8252 18.75 10 18.75ZM10 2.75C6.00195 2.75 2.75 6.00195 2.75 10C2.75 13.998 6.00195 17.25 10 17.25C13.998 17.25 17.25 13.998 17.25 10C17.25 6.00195 13.998 2.75 10 2.75Z"
        fill={fill}
      />
      <path
        d="M9.99219 12.7061C9.57813 12.7061 9.24219 12.3701 9.24219 11.9561C9.24219 10.9336 9.3125 10.2422 10.2812 9.27344C11.0664 8.48731 11.1992 8.17188 11.1992 7.62207C11.1992 7.41211 11.1328 6.36426 9.8252 6.36426C8.45997 6.36426 8.31446 7.52051 8.29883 7.75196C8.27246 8.16505 7.90625 8.47266 7.50195 8.45118C7.08789 8.42384 6.77539 8.06739 6.80273 7.6543C6.86621 6.68946 7.5791 4.86426 9.82519 4.86426C11.7119 4.86426 12.6992 6.25196 12.6992 7.62207C12.6992 8.76562 12.2422 9.43262 11.3418 10.334C10.7656 10.9101 10.7422 11.1455 10.7422 11.956C10.7422 12.3701 10.4062 12.7061 9.99219 12.7061Z"
        fill={fill}
      />
    </svg>
  );
};
